import React, {useState} from 'react';
import questionareStyle from '../../style';

export default function Slide6(props) {
	let style = questionareStyle();
	let [age, setAge] = useState(null);

	return (
		<div style={style.ageInputContainer()}>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				What is your age?
			</p>
			<input style={style.ageInput()} placeholder={35} type='number' onChange={updatedAge} />
			<button
				style={style.nextButton()}
				onClick={() => {
					props.nextPressed({
						age: age,
					});
				}}
			>
				Next
			</button>
		</div>
	);

	function updatedAge(e) {
		let value = e.target.value;
		setAge(value);
	}
}
